import React, { useState, useEffect } from 'react';
import { useValuation } from '../../context/ValuationContext';

interface ValuationResultsSupervisorProps {
  properties?: any;
}



const ValuationResultsSupervisor: React.FC<ValuationResultsSupervisorProps> = ({
  properties
}) =>{
  

  // ── RENDER ──────────────────────────────────────────────────────────────
    // Keep the existing valuation logic...
    const [valuation, setValuation] = useState({
      landValue: 0,
      buildingReplacementCost: 0,
      depreciatedValue: 0,
      amenitiesValue: 0,
      totalValue: 0,
      confidenceLevel: 0,
    });
    let amenitiesValue = 0;
    if (properties.annexHouseArea)
      amenitiesValue += properties.annexHouseArea * properties.annexRate;
    if (properties.fenceLength)
      amenitiesValue += properties.fenceLength * properties.fenceRate;
    if (properties.gardenArea)
      amenitiesValue += properties.gardenArea * properties.gardenRate;
    if (properties.retainingWallsLength)
      amenitiesValue +=
        properties.retainingWallsLength * properties.retainingWallRate;
    if (properties.entranceGateLength)
      amenitiesValue += properties.entranceGateLength * properties.entranceGateRate;
    if (properties.pavedArea)
      amenitiesValue += properties.pavedArea * properties.pavedAreaRate;
    if (properties.septicTankNumber)
      amenitiesValue += properties.septicTankNumber * properties.septicTankValue;
    if (properties.verandahArea)
      amenitiesValue += properties.verandahArea * properties.verandahRate;

    
  
    useEffect(() => {
      if ( properties?.valuationDetails) {
        const buildingReplacementCost =
          Number(properties.mainHouseArea) * properties.mainHouseRate;
        const depreciatedValue = buildingReplacementCost + amenitiesValue;
  
        setValuation({
          landValue: properties.valuationDetails.landValue || 0,
          buildingReplacementCost:
            Number(properties.mainHouseArea) * properties.mainHouseRate || 0,
          depreciatedValue:
            Number(properties.mainHouseArea) * properties.mainHouseRate +
              amenitiesValue || 0,
          amenitiesValue: amenitiesValue || 0,
          totalValue: properties.valuationDetails.landValue + depreciatedValue || 0,
          confidenceLevel: 100,
        });
      }
    }, [properties]);
  const { valuationResults, formatCurrency } = useValuation();

  // Currency detection based on property country
  const isUganda =
    !!properties?.location?.region ||
    properties?.location?.country === "UG";
  const currency = isUganda ? "UGX" : "RWF";

  const formatLocalCurrency = (value: number) => {
  if (!value && value !== 0) return `${currency} 0`;
  return `${currency} ${Math.round(value).toLocaleString()}`;
};

  return (
    <section className="mb-12 p-4 md:p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-lg font-semibold text-gray-900 mb-6">
        Estimated Value
      </h2>
      <div className="flex flex-col gap-4">
        <div className="bg-gray-50 p-4 rounded-lg shadow-inner">
          <h3 className="text-sm md:text-lg font-semibold text-gray-500">
            Open Market Value
          </h3>
          <p className="text-lg md:text-xl font-bold my-2 md:my-3 text-gray-900 break-words overflow-hidden">
            {formatLocalCurrency(valuation?.totalValue)}
          </p>
          <p className="text-xs text-gray-500">
            Estimated amount for which the property should exchange between a willing buyer and seller
          </p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg shadow-inner">
           <h3 className="text-sm md:text-lg font-semibold text-gray-500">
            Insurance Value
          </h3>
          <p className="text-lg md:text-xl font-bold my-2 md:my-3 text-gray-900 break-words overflow-hidden">
            {formatLocalCurrency(valuation.depreciatedValue)}
          </p>
          <p className="text-xs text-gray-500">
            Value for insurance purposes, typically covering replacement cost
          </p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg shadow-inner">
           <h3 className="text-sm md:text-lg font-semibold text-gray-500">
            Forced Sale Value
          </h3>
          <p className="text-lg md:text-xl font-bold my-2 md:my-3 text-gray-900 break-words overflow-hidden">
             {formatLocalCurrency(
                  valuation.totalValue *0.7
                )}
          </p>
          <p className="text-xs text-gray-500">
            Estimated realization price in forced sale circumstances
          </p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg shadow-inner">
           <h3 className="text-sm md:text-lg font-semibold text-gray-500">
            Improvements Value
          </h3>
          <p className="text-lg md:text-xl font-bold my-2 md:my-3 text-gray-900 break-words overflow-hidden">
            {formatLocalCurrency(valuation.amenitiesValue)}
          </p>
          <p className="text-xs text-gray-500">
            Total value of all buildings and improvements
          </p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg shadow-inner">
           <h3 className="text-sm md:text-lg font-semibold text-gray-500">
            Land Value
          </h3>
          <p className="text-lg md:text-xl font-bold my-2 md:my-3 text-gray-900 break-words overflow-hidden">
            {formatLocalCurrency(properties?.valuationDetails?.landValue)}
          </p>
          <p className="text-xs text-gray-500">
            Value of the land based on area and location
          </p>
        </div>
      </div>
    </section>
  );
};

export default ValuationResultsSupervisor;